import React from 'react'

export const SkyButton = ({ label, onClick }) => {
  return (
    <button
      className="text-white text-xs font-segoe-ui font-normal font-regular word-wrap-break py-2 px-4 bg-sky-500 rounded-md hover:bg-sky-400"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
export const SkyOutlinedButton = ({ label, onClick }) => {
  return (
    <button
      className="text-sky-500 text-xs font-segoe-ui font-normal font-regular word-wrap-break p-[6px] px-4 border border-sky-500 rounded-md hover:border-sky-400 hover:text-sky-400"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
export const CloseButton = ({ label, onClick }) => {
  return (
    <button
      type="button"
      className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center  "
      onClick={onClick}
    >
      <svg
        className="w-3 h-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        />
      </svg>
      <span className="sr-only">Close modal</span>
    </button>
  )
}

export const RadioButton = ({
  id,
  label,
  checked,
  onChange,
  size = 'h-4 w-4',
  fontSize = 'text-sm',
}) => {
  return (
    <div className="flex items-center">
      <div
        className={`bg-white dark:bg-gray-100 rounded-full ${size} flex flex-shrink-0 justify-center items-center relative`}
      >
        <input
          aria-labelledby={id}
          defaultChecked={checked}
          type="radio"
          name="radio"
          className="ml-2 focus: checkbox appearance-none focus:opacity-100  focus:ring-offset-2  focus:outline-none border rounded-full border-gray-300 absolute cursor-pointer w-full h-full checked:border-none opacity-50"
          onChange={onChange}
        />
        <div
          className={`check-icon ${
            checked ? 'block' : 'hidden'
          } border-4 border-[#435A97] rounded-full w-full h-full z-1`}
        ></div>
      </div>
      <label
        id={id}
        onClick={onChange}
        className={`ml-2 leading-4 ${
          checked
            ? 'text-zinc-700 font-normal'
            : "text-zinc-500 opacity-80 font-normal font-['Segoe UI']"
        } ${fontSize}`}
      >
        {label}
      </label>
    </div>
  )
}
export const CancelButton = ({ label, onClick }) => {
  return (
    <button
      className="text-white text-xs font-segoe-ui font-semibold font-regular word-wrap-break py-2 px-4 bg-red-500 rounded-md hover:bg-red-400"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
export const RemarkButton = ({ label, onClick }) => {
  return (
    <button
      className="text-white text-xs font-segoe-ui font-semibold font-regular word-wrap-break py-2 px-4 bg-sky-800 rounded-md hover:bg-sky-400"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
